import React from 'react';

const IconMinus = () => {
  return (
    <div style={{ pointerEvents: 'none' }}>
      <svg
        style={{ pointerEvents: 'none' }}
        width="16"
        height="2"
        viewBox="0 0 16 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1H16" stroke="#222222" strokeWidth="2" />
      </svg>
    </div>
  );
};

export default IconMinus;
